import moment from "moment";

/**
 * Return value in correct date format
 *
 * @param value
 * @param format
 * @returns {string}
 */
export default function(value, format = "DD/MM/YYYY") {
  // Check value exists
  if (!value) {
    return;
  }

  if (!(value instanceof moment)) {
    value = moment(String(value));
  }

  return value.format(format);
}
